<div id="timeline" class="timeline width-100 height-100">
  <div id="timeline-filters" class="padding-bottom-10">
    <div ng-repeat="filter in arrFilters track by $index">
      <div class="btn-group">
        <label class="btn btn-sm btn-white" ng-click="deleteFilterSelects($index)" ng-show="arrFilters.length > 1">
          <i class="fa fa-times"></i>
        </label>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}; border-left: {{arrFilters.length > 1 ? ('5px solid ' + filtersColors[$index].flat) : ''}}">
           {{filter.propriedade.descricao || 'Propriedade' | capitalize}}
        </label>
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           <span class="caret"></span>
        </label>
        <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="color:{{filtersColors[$index].flat}}">
          <li role="menuitem" ng-repeat="propriedade in propriedades track by propriedade.id">
            <a ng-click="setPropriedade($parent.$index, propriedade, $event)" href="#">{{::propriedade.descricao | capitalize}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" ng-show="filter.loadings.selectFilters">
        <span>
          <i class="pull-right fa fa-spinner fa-spin"></i>
        </span>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-hide="filter.loadings.selectFilters">
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
          {{(filter.gleba.descricao || 'Talhão') | capitalize}}
        </label>
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           <span class="caret"></span>
        </label>
        <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="color:{{filtersColors[$index].flat}}">
          <li role="menuitem" ng-show="filter.gleba">
            <a ng-click="setGleba($index, null, $event)" href="#">
              Limpar Seleção
            </a>
          </li>
          <li class="divider" ng-show="filter.gleba"></li>
          <li role="menuitem" ng-repeat="gleba in filter.filters.glebas track by gleba.id">
            <a ng-click="setGleba($parent.$index, gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-hide="filter.loadings.selectFilters">
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           {{getCheckedItems(filter.filters.operacoes) || 'Operações' | capitalize | characters:40}}
        </label>
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           <span class="caret"></span>
        </label>
        <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="color:{{filtersColors[$index].flat}}">
          <li role="menuitem" ng-show="getCheckedItems(filter.filters.operacoes)">
            <a ng-click="setOperacao($index, null, $event)" href="#">
              Limpar Seleção
            </a>
          </li>
          <li class="divider" ng-show="getCheckedItems(filter.filters.operacoes)"></li>
          <li role="menuitem" ng-repeat="operacao in filter.filters.operacoes track by operacao.id">
            <a ng-click="setOperacao($parent.$index, operacao, $event)" href="#">
              <i class="fa fa-check" ng-show="operacao.checked"></i> {{::operacao.descricao | capitalize}}
            </a>
          </li>
        </ul>
      </div>

      <div class="btn-group" ng-show="filter.loadings.ocorrenciasInsumosFilter">
        <span>
          <i class="pull-right fa fa-spinner fa-spin"></i>
        </span>
      </div>

      <div class="filters-column" ng-show="!filter.loadings.ocorrenciasInsumosFilter && (isOperacaoOcorrencias($index) || isOperacaoGrupoInsumos($index))">
        <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle
             ng-show="isOperacaoOcorrencias($parent.$index)"
             ng-repeat="(key, ocorrencias) in filter.filters.ocorrencias">
          <label type="button" class="btn btn-white btn-sm width-100" style="color:{{filtersColors[$parent.$index].flat}}">
             {{getCheckedItems(ocorrencias) || key+'s' | capitalize | characters:40}}
          </label>
          <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$parent.$index].flat}}">
             <span class="caret"></span>
          </label>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="color:{{filtersColors[$index].flat}}">
            <li role="menuitem" ng-show="getCheckedItems(ocorrencias)">
              <a ng-click="setOcorrencia($parent.$index, null, ocorrencias, $event)" href="#">
                Limpar Seleção
              </a>
            </li>
            <li class="divider" ng-show="getCheckedItems(ocorrencias)"></li>
            <li role="menuitem" ng-repeat="ocorrencia in ocorrencias track by ocorrencia.id">
              <a ng-click="setOcorrencia($parent.$parent.$index, ocorrencia, ocorrencias, $event)" href="#">
                <i class="fa fa-check" ng-show="ocorrencia.checked"></i> {{::ocorrencia.descricao | capitalize}}
              </a>
            </li>
          </ul>
        </div>

        <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle
             ng-show="isOperacaoGrupoInsumos($index)">
          <label type="button" class="btn btn-white btn-sm width-100" style="color:{{filtersColors[$index].flat}}">
             {{getCheckedItems(filter.filters.gruposInsumos) || 'Grupo de Insumos' | capitalize | characters:40}}
          </label>
          <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
             <span class="caret"></span>
          </label>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="color:{{filtersColors[$index].flat}}">
            <li role="menuitem" ng-show="getCheckedItems(filter.filters.gruposInsumos)">
              <a ng-click="setGrupoInsumo($index, null, $event)" href="#">
                Limpar Seleção
              </a>
            </li>
            <li class="divider" ng-show="getCheckedItems(filter.filters.gruposInsumos)"></li>
            <li role="menuitem" ng-repeat="grupoInsumo in filter.filters.gruposInsumos">
              <a ng-click="setGrupoInsumo($parent.$index, grupoInsumo, $event)" href="#">
                <i class="fa fa-check" ng-show="grupoInsumo.checked"></i> {{::grupoInsumo.descricao | capitalize}}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-hide="filter.loadings.selectFilters">
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           {{(filter.cultura.descricao || 'Cultura') | capitalize}}
        </label>
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           <span class="caret"></span>
        </label>
        <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="color:{{filtersColors[$index].flat}}">
          <li role="menuitem" ng-show="filter.cultura">
            <a ng-click="setCultura($index, null, $event)" href="#">
              Limpar Seleção
            </a>
          </li>
          <li class="divider" ng-show="filter.cultura"></li>
          <li role="menuitem" ng-repeat="cultura in filter.filters.culturas track by cultura.id">
            <a ng-click="setCultura($parent.$index, cultura, $event)" href="#">{{::cultura.descricao | capitalize}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           {{filter.filters.period.periodo || 'Período'}}
        </label>
        <label type="button" class="btn btn-white btn-sm" style="color:{{filtersColors[$index].flat}}">
           <span class="caret"></span>
        </label>
        <ul class="dropdown-menu" uib-dropdown-menu role="menu" style="color:{{filtersColors[$index].flat}}">
          <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
            <a ng-click="setPeriodo($parent.$index, periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
          </li>
          <li role="menuitem">
            <a ng-click="openPeriodsFilter($index, $event)" href="#">Customizado</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" ng-show="$index == arrFilters.length-1">
        <label class="btn btn-success btn-sm" ng-click="getTimeline()">
          Pesquisar
        </label>
      </div>

      <div class="btn-group" ng-show="$index == arrFilters.length-1">
        <label class="btn btn-danger btn-sm" ng-click="limparFiltros()">
          Limpar
        </label>
      </div>

      <div class="btn-group pull-right" ng-show="$index == 0">
        <label type="button" ng-repeat="(key, value) in filterQuebra" class="btn btn-primary btn-sm"
               ng-click="setQuebra(value)" ng-class="{active: (quebra) ? value == quebra : value == filterQuebra.dia}">
          {{::value.descricao}}
        </label>
      </div>

      <div class="btn-group pull-right padding-right-5" ng-show="canDisplayDadosMeteorologicos()"
           uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
        <label type="button" class="btn btn-white btn-sm">
           {{dadosMeteorologicos.dados[dadosMeteorologicos.selected][0].descricao || 'Todos'}}
        </label>
        <label type="button" class="btn btn-white btn-sm">
           <span class="caret"></span>
        </label>
        <ul class="dropdown-menu" uib-dropdown-menu role="menu">
          <li role="menuitem">
            <a ng-click="setPluviometro('TODOS', $event)" href="#">
              Todos
            </a>
          </li>

          <li role="menuitem" ng-repeat="(key, value) in dadosMeteorologicos.dados">
            <a ng-click="setPluviometro(key, $event)" href="#">
              {{::dadosMeteorologicos.dados[key][0].descricao}}
              <small ng-if="pluviometros[key].glebas.length"><br />{{pluviometros[key].glebas | getTextItems}}</small>
            </a>
          </li>
        </ul>
      </div>

      <br>
      <div class="btn-group pull-right" ng-hide="$index">
        <label class="btn btn-sm" ng-click="addFilterSelects()" ng-disabled="arrFilters.length >= maxFilterIndex"
               style="border-color:{{filtersColors[arrFilters.length].flat}}; color:{{filtersColors[arrFilters.length].flat}}">
          <i class="fa fa-plus"></i> Comparar
        </label>
      </div>
    </div>
  </div>

  <div id="timeline-container">
    <div class="container-column" ng-repeat="(key, values) in dados track by $index">
      <div class="lines">
        <div class="clearfix"></div>
        <div class="container-dados">
          <div class="column-container" style="border-bottom: 4px solid {{filtersColors[keyColumn].flat}};">
            <div class="dados-column" ng-repeat="(keyColumn, column) in values track by $index">
              <div ng-init="idColumn = 'column-' + $parent.$index + '-' + $index" class="column" id="{{idColumn}}" >
                <div class="row-container" style="background-color:{{filtersColors[keyColumn].color}};">
                  <a ng-href="{{goToPropriedade(row, keyColumn)}}" class="row icon label bg-{{row.situacao}} pointer {{row.tipo}}" ng-repeat="row in column" ng-click="goToPropriedade(row, keyColumn)">
                    <i agro-icon-historico historico="{tipo: row.tipo}" tipped tipped-template="tooltip-hint.html" tipped-position="right" tipped-behavior="mouse"></i>
                  </a>
                </div>
              </div>
              <i class="fa fa-chevron-up pointer arrowTop" aria-hidden="true" agro-scroll scroll-top="-50" scroll-element-id="{{idColumn}}" scroll-initialize-position="bottom">
              </i>
              <i class="fa fa-chevron-down pointer arrowBottom" aria-hidden="true" agro-scroll scroll-top="50" scroll-element-id="{{idColumn}}">
              </i>
            </div>
          </div>
        </div>
        <div class="title vertical-center" ng-hide="isQuebraEstadio(quebraSelected)" ng-class="{'border-radius-left': $index == 0, 'border-radius-right': isLastIndexDados($index)}">
          <h3 class="no-margin">{{key | date: 'dd'}}</h3>
          <span class="text-light">{{key | date: 'MMM'}}</span>
        </div>

        <div class="title vertical-center" ng-show="isQuebraEstadio(quebraSelected)" ng-class="{'border-radius-left': $index == 0, 'border-radius-right': isLastIndexDados($index)}">
          <h3 class="no-margin" tipped tipped-content="{{getEstadioRegistro(values).descricao | capitalize}}" tipped-position="right" tipped-behavior="mouse">
            {{getEstadioRegistro(values).abreviatura | characters:11}}
          </h3>
          <span class="text-light" ng-show="getEstadioRegistro(values).id">{{getDataEstadioRegistro(values) | date: 'dd/MM'}}</span>
          <span class="text-light" ng-hide="getEstadioRegistro(values).id">&nbsp;</span>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</div>

<script type="text/ng-template" id="tooltip-hint.html">
  <div class="text-left">
    <div>
      {{row.tipo_to_pt_br}}
      <span ng-show="row.gleba.descricao">
        - {{row.gleba.descricao | capitalize}}
      </span>
    </div>
    <div ng-repeat="hint in row.hint track by $index">
      {{hint}}
    </div>
  </div>
</script>
